import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import OTPInput from "react-otp-input";

import MainPagetitle from "../../../layouts/MainPagetitle";
import EmployeeModal from "./EmployeeModal";
import EmployeeSearch from "./EmployeeSearch/EmployeeSearch";
import RepaymentModal from "../LoanDetails/Repayments/RepaymentModal";

const Employees = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [modalFields, setModalFields] = useState([
    {
      label: "Employee Name",
      name: "name",
      type: "text",
      placeholder: "Please Enter",
    },
    {
      label: "Role",
      name: "role",
      type: "select",
      options: [],
    },
    {
      label: "Email ID",
      name: "emailAddress",
      type: "email",
      placeholder: "Please Enter",
      onChange: (value) => handleEmailId(value),
    },
    {
      label: "Mobile No.",
      name: "mobileNumber",
      type: "text",
      // defaultValue: "9876545432",
      placeholder: "Please Enter",
      onChange: (value) => handleMobileNo(value),
    },
    {
      label: "Work Location",
      name: "workLocation",
      type: "select",
      options: [],
      onChange: (value) => {
        setLocation(value);
      },
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "State",
      name: "state",
      type: "text",
      readOnly: true,
      // options: Object.keys(statecity).options(),
      // onChange: (value) => {
      //   getCities(value);
      // },
      placeholder: "Please Enter",
    },
    {
      label: "City",
      name: "city",
      type: "text",
      readOnly: true,
      // options: [],
      placeholder: "Please Enter",
    },
    {
      label: "Reporting Manager",
      name: "reportingPerson",
      type: "select",
      options: [],
      placeholder: "Please Enter",
    },
    {
      label: "Joining Date",
      name: "joiningDate",
      type: "date",
      defaultValue: new Date(),
    },
    {
      label: "Status",
      name: "status",
      type: "select",
      options: _enum.STATUS,
      placeholder: "Please Enter",
    },
  ]);
  const [editData, setEditData] = useState([]);
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});

  const [initialStatus, setInitialStatus] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpError, setOtpError] = useState("");
  const [pendingUpdateData, setPendingUpdateData] = useState(null);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isSubmittingOtp, setIsSubmittingOtp] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
    let interval = null;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [resendTimer]);

  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [locations, setLocations] = useState([]);
  const [productType, setProductType] = useState([]);
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });

  const [rowcount, setRowcount] = useState(0);
  const columns = [
    {
      dataIndex: "name",
      title: "Name",
      sorter: (a, b) => a.name.length - b.name.length,
      render: (text, record) => {
        return (
          <div className="products">
            <div>
              <h6 className="text-primary">{record.profileId}</h6>
              <span>{record.name}</span>
            </div>
          </div>
        );
      },
    },
    {
      dataIndex: "mobileNumber",
      title: "Mobile No.",
    },
    {
      dataIndex: "emailAddress",
      title: "Email ID",
    },
    {
      dataIndex: "joiningDate",
      title: "Joining Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.joiningDate) {
          return date;
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "role",
      title: "Role",
      render: (text, record) => {
        return <>{text?.toTitleCase()}</>;
      },
    },
    {
      dataIndex: "city",
      title: "Location",
      render: (text, record) => {
        return <>{record?.city || "-"}</>;
      },
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text, record) => {
        return (
          <span
            className={`badge light border-0 ${text.toLowerCase() === "active" ? "badge-success" : "badge-danger"
              } `}
          >
            {text?.toTitleCase()}
          </span>
        );
      },
    },
  ];

  const onPageChange = (pageData) => {
    console.log({ onPageChange: pageData });
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 10,
    });
  };

  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  // const getCities = (value) => {
  //   // console.log({ getCities: value });
  //   let city = modalFields.find((o) => o.name == "city");
  //   city.options = Object.assign(
  //     city.options,
  //     statecity[value[0].key].options()
  //   );
  //   setModalFields([...modalFields]);
  // };

  const setLocation = (record) => {
    console.log({ setLocation: record[0] });
    let statefield = modalFields.find((o) => o.name == "state");
    statefield.defaultValue = record[0]?.state;

    let cityfield = modalFields.find((o) => o.name == "city");
    cityfield.defaultValue = record[0]?.city;

    // if (record[0] === undefined) {
    //   console.log("reset cityfield");
    //   // statefield.defaultValue = "";
    //   // cityfield.defaultValue = "";
    //   let stateinput = document.querySelector(
    //     "[name='appinput-state'].form-group input"
    //   );
    //   let cityinput = document.querySelector(
    //     "[name='appinput-city'].form-group input"
    //   );
    //   stateinput.value = "";
    //   cityinput.value = "";
    // }

    setModalFields([...modalFields]);
  };

  const getRoles = () => {
    props.apis.apiGetMasterRoles().then((res) => {
      // console.log({ roles: res });
      let role = modalFields.find((o) => o.name == "role");
      role.options = res.options("role");
      setModalFields([...modalFields]);
      setRoles(res);
      //
      // let role = modalFields.find((o) => o.name == "role");
      // let roles = res.filter((v) => v.role !== "ADMIN");
      // role.options = roles.options("role");
      // setRoles(res);
    });
  };

  const getDepartments = () => {
    props.apis.apiGetMasterDepartments().then((res) => {
      // console.log({ department: res, modalFields });
      let department = modalFields.find((o) => o.name == "department");
      let reportingDepartment = modalFields.find(
        (o) => o.name == "reportingDepartment"
      );
      department.options = res.options("department");
      reportingDepartment.options = res.options("department");
      setModalFields([...modalFields]);
      setDepartments(res);
    });
  };

  const getDesignations = () => {
    props.apis.apiGetMasterDesignations().then((res) => {
      let designation = modalFields.find((o) => o.name == "designation");
      let reportingDesignation = modalFields.find(
        (o) => o.name == "reportingDesignation"
      );
      designation.options = res.options("designation");
      reportingDesignation.options = res.options("designation");
      setModalFields([...modalFields]);
      setDesignations(res);
    });
  };

  const getLocations = () => {
    let payload = {
      ...search,
    };
    // props.apis.apiGetMasterLocations(payload).then(({ data }) => {
    //   // console.log({ apiGetMasterLocations: data });
    //   let location = modalFields.find((o) => o.name == "locationId");
    //   location.options = data.options("locationId", "locationName");
    //   setLocations(data);
    //   setOpenCanvas(false);
    // });
    let data = [
      // {
      //   locationId: 1,
      //   locationName: "Hyderabad",
      //   city: "Hyderabad",
      //   state: "Telangana",
      //   latitude: "17.366",
      //   longitude: "78.476",
      //   status: "active",
      // },
      {
        locationId: 2,
        locationName: "Delhi",
        city: "Delhi",
        state: "Union Territory of Delhi",
        latitude: "28.7",
        longitude: "77.1",
        status: "active",
      },
    ];
    let location = modalFields.find((o) => o.name == "workLocation");
    location.options = data.options("locationName");
  };

  const getProductTypes = () => {
    props.apis.apiGetProductTypes().then((res) => {
      let productType = modalFields.find((o) => o.name == "productType");
      productType.options = res.options("productType");
      setModalFields([...modalFields]);
      setProductType(res);
    });
  };

  const getEmployees = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ["page", "limit"]);
      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    props.apis.apiGetEmployee(payload).then(({ data, total }) => {
      console.log({ apiGetEmployee: data, total });
      data = data?.map((obj) => {
        let newObj = { ...obj };
        if (obj?.joiningDate) {
          newObj.joiningDate = new Date(obj.joiningDate).toDate();
        } else {
          newObj.joiningDate = null;
        }
        return newObj;
      });
      let reportingPersons = modalFields.find(
        (o) => o.name == "reportingPerson"
      );
      reportingPersons.options = data.options("name");
      // console.log({ data });
      setTableData(data);
      setIsFetching(false);
      setRowcount(total);
    });
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on leads", data, reset);
    let defaultSearchData = Object.only(data, ["limit", "page"]);
    let payload;
    if (reset) {
      payload = {
        ...defaultSearchData,
      };
      getEmployees(payload, reset);
    } else {
      payload = {
        ...data,
        page: 1,
        limit: 10,
      };
      getEmployees(payload, reset);
    }
    setSearch(payload);
  };

  const deleteEmployee = (record) => {
    console.log({ deleteEmployee: record });
    if (record.department === "Adminstration") {
      swal2.fire({
        title: "Administrative accounts cannot be deleted",
        icon: "error",
        iconColor: "#FF4D4D",
        showCancelButton: false,
        timer: 3000,
      });
    } else {
      swal2
        .fire({
          title: "Are you sure you want to delete this employee?",
          icon: "warning",
          iconColor: "#FF4D4D",
          showCancelButton: true,
          confirmButtonColor: "#FF4D4D",
          cancelButtonColor: "##D6DBE7",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            props.apis
              .apiDeleteEmployee({ profileId: record.profileId })
              .then((res) => {
                console.log({ apiDeleteEmployee: res });
                swal2.fire({
                  title: "Employee Deleted",
                  text: "Employee deleted successfully !!",
                  icon: "success",
                  iconColor: "#FF4D4D",
                  timer: 4000,
                });
                getEmployees();
              });
          }
        });
    }
  };

  const viewEmployee = (record) => {
    setEditmode(false);
    setViewmode(true);
    // GET EMPLOYEE BY ID
    props.apis
      .apiGetEmployeeById({ profileId: record.profileId })
      .then((data) => {
        console.log({ apiGetEmployeeById: data });
        let filteredData = Object.only(
          data,
          modalFields.map((v) => v.name)
        );
        console.log({ filteredData });
        setPopupdata(filteredData);
        setEditData(data);
        openModal();
      });
  };

  const editEmployee = (record) => {
    console.log({ record });
    setEditmode(true);
    setViewmode(false);
    // GET EMPLOYEE BY ID
    props.apis
      .apiGetEmployeeById({ profileId: record.profileId })
      .then((data) => {
        console.log({ apiGetEmployeeById: data });
        let filteredData = Object.only(
          data,
          modalFields.map((v) => v.name)
        );
        console.log({ filteredData });
        setPopupdata(filteredData);
        setEditData(data);
        const originalEmpStatus = (data?.status || record?.status || "").toString();
        setInitialStatus(originalEmpStatus);
        // let nameField = modalFields.find((o) => o.name == "name");
        // nameField.disabled = true;
        setModalFields([...modalFields]);
        openModal();
      });
  };

  const handleMobileNo = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue) && fieldValue.length === 10)
      setErrorMessage("");
    else
      setErrorMessage({
        name: "mobileNumber",
        message: "Please enter a valid Mobile Number",
      });
  };

  const handleEmailId = (e) => {
    const emailReg = _enum?.REGEX?.email;
    const fieldValue = e.target.value;
    if (emailReg.test(fieldValue)) setErrorMessage("");
    else
      setErrorMessage({
        name: "emailAddress",
        message: "Please enter a valid Email Address",
      });
  };

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    console.log("formdata: ", data);
    let formdata = data;
    let payload = {
      ...Object.except(formdata, [
        "reportingDepartment",
        "reportingDesignation",
        "reportingPerson",
        "workLocation",
        // "state",
        // "city",
        "address",
        "picture",
      ]),
    };
    if (formdata.joiningDate) {
      payload.joiningDate = new Date(formdata.joiningDate).toISOString();
    }
    payload.workLocation = data?.workLocation;
    payload.supervisorId = props?.$store?.user?.profileId || "";
    console.log({ payload });

    if (editmode) {
      let updateData = {
        ...Object.except(payload, ["profileId"]),
      };

      const originalEmpStatus = (initialStatus || editData?.status || "").toString().trim().toLowerCase();
      const newEmpStatus = (updateData?.status || "").toString().trim().toLowerCase();
      const hasStatusChanged = Boolean(originalEmpStatus && newEmpStatus && originalEmpStatus !== newEmpStatus);

      if (hasStatusChanged) {
        setIsSendingOtp(true);
        setPendingUpdateData(updateData);
        props.apis
          .apiSendEmployeeOtp()
          .then((res) => {
            setIsSendingOtp(false);
            setOtpValue("");
            setOtpError("");
            setResendTimer(30);
            setShowOtpModal(true);
            if (res?.message) {
              swal2.fire({
                title: res.message,
                icon: "success",
                iconColor: "#FF4D4D",
                timer: 3000,
              });
            }
          })
          .catch((err) => {
            setIsSendingOtp(false);
            console.log("Failed to send profile OTP:", err);
            const errMessage = (
              err?.response?.data?.message ||
              err?.message ||
              "Failed to send OTP. Please try again."
            );
            swal2.fire({
              title: errMessage,
              icon: "error",
              iconColor: "#FF4D4D",
            });
          });
      } else {
        props.apis
          .apiUpdateEmployee(updateData, {
            profileId: editData?.profileId,
          })
          .then((res) => {
            console.log({ apiUpdateEmployee: res });
            swal2.fire({
              title: "Employee updated successfully.",
              icon: "success",
              iconColor: "#FF4D4D",
              timer: 4000,
            });
            closeModal();
            getEmployees();
          })
          .catch((error) => console.log(error));
      }
    } else {
      props.apis
        .apiAddEmployee(payload)
        .then((res) => {
          console.log({ apiAddEmployee: res });
          swal2.fire({
            title: "Employee added successfully.",
            icon: "success",
            iconColor: "#FF4D4D",
            timer: 4000,
          });
          closeModal();
          getEmployees();
        })
        .catch((error) => console.log(error));
    }
  };

  const handleVerifyOtpAndSave = () => {
    if (!otpValue || otpValue.trim().length !== 6) {
      setOtpError("Please enter a valid 6-digit OTP");
      return;
    }

    if (!pendingUpdateData) {
      setOtpError("Update data is missing. Please close and try again.");
      return;
    }

    setIsSubmittingOtp(true);
    setOtpError("");

    const updatePayloadWithOtp = {
      ...pendingUpdateData,
      otpCode: otpValue.trim(),
    };

    props.apis
      .apiUpdateEmployee(
        updatePayloadWithOtp,
        {
          profileId: editData?.profileId,
        },
        { "X-Suppress-Error": true }
      )
      .then((res) => {
        setIsSubmittingOtp(false);
        document.getElementById("globalLoader")?.classList.add("d-none");
        setShowOtpModal(false);
        setOtpValue("");
        setOtpError("");
        setInitialStatus(pendingUpdateData.status);
        setPendingUpdateData(null);
        swal2.fire({
          title: "Employee updated successfully.",
          icon: "success",
          iconColor: "#FF4D4D",
          timer: 4000,
        });
        closeModal();
        getEmployees();
      })
      .catch((error) => {
        setIsSubmittingOtp(false);
        document.getElementById("globalLoader")?.classList.add("d-none");
        console.log("OTP verify update error:", error);
        const backendMessage = (
          error?.response?.data?.message ||
          error?.response?.data?.issues?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Invalid OTP. Please check and re-try."
        );
        setOtpError(backendMessage);
      });
  };

  const handleResendOtp = () => {
    if (resendTimer > 0 || isSendingOtp) return;
    setIsSendingOtp(true);
    setOtpError("");
    props.apis
      .apiSendEmployeeOtp()
      .then((res) => {
        setIsSendingOtp(false);
        document.getElementById("globalLoader")?.classList.add("d-none");
        setResendTimer(30);
        setOtpValue("");
        if (res?.message) {
          swal2.fire({
            title: res.message,
            icon: "success",
            iconColor: "#FF4D4D",
            timer: 3000,
          });
        }
      })
      .catch((err) => {
        setIsSendingOtp(false);
        document.getElementById("globalLoader")?.classList.add("d-none");
        const errMessage = (
          err?.response?.data?.message ||
          err?.message ||
          "Failed to resend OTP. Please try again."
        );
        setOtpError(errMessage);
      });
  };

  const handleCloseOtpModal = () => {
    setShowOtpModal(false);
    setOtpValue("");
    setOtpError("");
    setPendingUpdateData(null);
  };

  const addModalFields = (values) => {
    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    console.log("formdata: ", fields, formdata);
    setInitialStatus("");
    setPendingUpdateData(null);
    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const onModalClose = () => {
    console.log("onModalClose");
    closeModal();
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
    setErrorMessage({ name: "", message: "" });
    setInitialStatus("");
    setPendingUpdateData(null);
  };

  const downloadExcel = async () => {
    let payload = {};
    props.apis.apiExportEmployeesDetails(payload).then(async (res) => {
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `employees_${new Date().toDate()}.xlsx`);
        link.click();
      }
    });
  };

  useEffect(() => {
    getEmployees();
  }, [search]);

  useEffect(() => {
    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    setPopupfields(fields);
  }, [editData]);

  useEffect(() => {
    console.log({ Employees: props });
    getRoles();
    // getDepartments();
    // getDesignations();
    getLocations();
    // getProductTypes();
  }, []);

  props.$setNode({
    props,
    modalFields,
    viewmode,
    editmode,
  });

  return (
    <>
      <MainPagetitle
        mainTitle="Employee"
        pageTitle={"Employee"}
        parentTitle={"Home"}
        pageIcon={imagepaths.LeadsIconActive}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="tbl-caption-container justify-content-between">
                  <h4 className="heading mb-0">Employees</h4>
                  <EmployeeSearch
                    onSearch={(...arg) => onSearch(...arg)}
                    addModalFields={(...arg) => addModalFields(...arg)}
                    downloadExcel={(...arg) => downloadExcel(...arg)}
                    roles={roles}
                  />
                </div>
                {/* {!!tableData.length && (
                )}
                {tableData.length == 0 && <div className="empty_layout"></div>} */}
                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => onPageChange(...arg)}
                  total={rowcount}
                  reorder={true}
                  editAction={(e) => editEmployee(e)}
                  viewAction={(e) => viewEmployee(e)}
                  deleteAction={(e) => deleteEmployee(e)}
                  loading={isFetching}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RepaymentModal
        id="employeeCanvas"
        title={`${editmode
            ? "Edit Employee"
            : viewmode
              ? "View Employee"
              : "Add Employee"
          }`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        editmode={editmode}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Submit"}`}
        disableallfields={viewmode ? true : false}
        errorMessage={errorMessage}
      />
      {/* Admin OTP Verification Modal for Employee Status Change */}
      <Modal
        show={showOtpModal}
        onHide={handleCloseOtpModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">OTP Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          <div className="row g-3">
            <div className="col-12 text-center">
              <p className="text-muted mb-3">
                Changing employee status requires verification. Enter the 6-digit OTP sent to Admin.
              </p>
              <div className="d-flex justify-content-center">
                <OTPInput
                  value={otpValue}
                  onChange={(otp) => {
                    setOtpValue(otp);
                    if (otpError) setOtpError("");
                  }}
                  separator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                  numInputs={6}
                  shouldAutoFocus={true}
                  isInputNum={true}
                  containerStyle="otp_container small p-0"
                />
              </div>
              {otpError && (
                <div className="alert alert-danger py-2 mt-3 text-center small mb-0">
                  {otpError}
                </div>
              )}
            </div>

            <div className="col-12 text-center">
              <div className="text-center otp_bottom">
                <span className="me-2 text-muted small">
                  {resendTimer > 0 ? (
                    <>Resend OTP in <strong className="text-primary">{resendTimer}s</strong></>
                  ) : (
                    "Didn't receive the OTP?"
                  )}
                </span>
                <button
                  type="button"
                  className="btn btn-link p-0 text-decoration-none small"
                  disabled={resendTimer > 0 || isSendingOtp}
                  onClick={handleResendOtp}
                >
                  {isSendingOtp ? "Sending..." : "Resend"}
                </button>
              </div>
            </div>

            <div className="col-12 d-flex justify-content-end mt-4">
              <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={handleCloseOtpModal}
                disabled={isSubmittingOtp}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleVerifyOtpAndSave}
                disabled={otpValue.length !== 6 || isSubmittingOtp}
              >
                {isSubmittingOtp ? "Verifying..." : "Confirm & Save"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(Employees);
